module.exports = __webpack_public_path__ + "img/IWG_norms_img.09e29484.png";